export const convertSrtToVtt = (srtContent: string): string => {
  let vttContent = "WEBVTT\n\n";

  // Split into lines and process
  const lines = srtContent.trim().split("\n");
  let i = 0;

  while (i < lines.length) {
    // Skip subtitle number
    i++;

    // Handle timestamp line
    if (i < lines.length) {
      // Replace , with . in timestamps
      const timestampLine = lines[i].replace(/,/g, ".");
      vttContent += timestampLine + "\n";
      i++;
    }

    // Add subtitle text
    while (i < lines.length && lines[i].trim() !== "") {
      vttContent += lines[i] + "\n";
      i++;
    }

    // Add extra newline between subtitles
    vttContent += "\n";
    // Skip empty lines
    while (i < lines.length && lines[i].trim() === "") {
      i++;
    }
  }

  return vttContent;
};
